import '../CsvJsonInfoPages.scss';


function CommentLink() {

    const data = [
        { field: 1, description: 'Sequence Number' },
        { field: 2, description: 'CAP ID Number' },
        { field: 3, description: 'Comment Number' },
    ];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>Used Values Live - Comment Link</h1>
            <p> Cross reference that links comments to specific vehicles.<br /><br />
                <b>File Naming Convention</b></p>
            <p>The Filename is dependent on the product being produced as follows.<br/><br/>
                CAR_yyyy-mm-dd_UsedValuesLive_CommentLink.txt<br/><br/>

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => (
                        <tr key={index}>
                            <td>{row.field}</td>
                            <td>{row.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default CommentLink;
